/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy API
 * API for Pharmacy
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PharmacyPharmacyListImageTypename = "PharmacyPharmacyListImage" as const;

/**
 *
 * @export
 * @interface PharmacyPharmacyListImage
 */
export interface PharmacyPharmacyListImage {
  /**
   *
   * @type {string}
   * @memberof PharmacyPharmacyListImage
   */
  detail?: string;
  /**
   *
   * @type {string}
   * @memberof PharmacyPharmacyListImage
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof PharmacyPharmacyListImage
   */
  url?: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PharmacyPharmacyListImage
   */
  readonly __typename?: string;
}

export function PharmacyPharmacyListImageFromJSON(json: any): PharmacyPharmacyListImage {
  return PharmacyPharmacyListImageFromJSONTyped(json, false);
}

export function PharmacyPharmacyListImageFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PharmacyPharmacyListImage {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PharmacyPharmacyListImageTypename,

    detail: !exists(json, "detail") ? undefined : json["detail"],
    id: !exists(json, "id") ? undefined : json["id"],
    url: !exists(json, "url") ? undefined : json["url"],
  };
}

export function PharmacyPharmacyListImageToJSON(object?: PharmacyPharmacyListImage | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    detail: value.detail,
    id: value.id,
    url: value.url,
  };
}
